import { createSlice } from '@reduxjs/toolkit';
import { IUser } from 'constants/user.constants';

interface IUserState {
	details?: IUser | null;
}

const initialState: IUserState = {
	details: {
		id: 0,
		firstName: '',
		lastName: '',
		email: '',
		displayName: '',
		username: '',
		role: '',
		nameID: '',
		phone: '',
		groups: [],
		permissions: [],
	},
};

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		loginUser: (state, { payload }) => {
			const {
				userId: id,
				firstName,
				lastName,
				email,
				displayName,
				username,
				role,
				phone,
				nameID,
				groups,
			} = payload;
			state.details = {
				id,
				firstName,
				lastName,
				email,
				displayName,
				username,
				role,
				phone,
				nameID,
				groups,
				permissions: [],
			};
		},
		clearUser: (state) => {
			state.details = initialState.details;
		},
		setUserPermissions: (state, { payload }) => {
			state.details!.permissions = payload as string[];
		},
	},
});

export const getUserDetails = (state: any) => {
	return state.user.details;
};

export const { loginUser, clearUser, setUserPermissions } = userSlice.actions;

export default userSlice.reducer;
